import singleFileAudioPlayer from "@/components/SingleFileAudioPlayer/Wrapper.vue";
import {options, default as Vue} from "../base";

Vue.customElement('vue-audio-player', singleFileAudioPlayer, options)
